if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            const button = mediaToSwitch.querySelector('button');

            if (!button) return;

            button.addEventListener(
              'click',
              this.setActiveMedia.bind(
                this,
                mediaToSwitch.dataset.target,
                false
              )
            );
          });

        if (
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const current = event.detail.currentElement;
        if (!current) return;

        // Native scrolling changes the visible slide without calling
        // setActiveMedia. Keep the selected slide in step for variants and
        // when the gallery returns to its desktop layout.
        if (
          this.closest('.gt-single-pdp') &&
          window.matchMedia('(max-width: 989px), (hover: none) and (pointer: coarse)').matches
        ) {
          const previous = this.elements.viewer.querySelector('.product__media-item.is-active');
          if (previous && previous !== current) window.pauseAllMedia();
          this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]').forEach((item) => {
            item.classList.toggle('is-active', item === current);
          });
        }
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${current.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) {
          return;
        }

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        if (prepend) {
          if (
            activeMedia.parentElement.firstChild !== activeMedia
          ) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (
              activeThumbnail &&
              activeThumbnail.parentElement.firstChild !==
                activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(
                activeThumbnail
              );
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        /*
         * Keep the chosen variant image selected within the
         * horizontal gallery, without scrolling the webpage
         * back to the product images.
         */
        window.setTimeout(() => {
          if (
            !this.mql.matches ||
            this.elements.thumbnails
          ) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'auto',
            });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) {
          return;
        }

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        const thumbnailButton =
          thumbnail.querySelector('button');

        if (!thumbnailButton) return;

        thumbnailButton.setAttribute(
          'aria-current',
          true
        );

        if (
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            10
          )
        ) {
          return;
        }

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image || !this.elements.liveRegion) {
          return;
        }

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach(
          (slide) => {
            slide.setAttribute(
              'role',
              'presentation'
            );
          }
        );
      }
    }
  );
}
